import { styled } from 'baseui'
import { FlexColumn, FlexCenterY } from '@/shared/theme/styled-components'

export const StyledIcon = styled('img', () => ({
  width: '1.5rem',
  height: '1.5rem',
  marginRight: '.25rem',
}))

export const StyledTitle = styled('h3', ({ $theme }) => ({
  flexGrow: 1,
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  fontFamily: 'Family/Body',
  fontWeight: 600,
  fontSize: '18px',
  letterSpacing: '-1.4%',
  color: $theme.colors.textHeading,
  height: '1.5rem',
}))

export const StyledTitleContainer = styled(FlexColumn, {})

export const StyledPanelWrapper = styled(FlexColumn, {
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  marginBottom: '0.9375rem',
})

export const StyledHeaderContainer = styled(FlexCenterY, {
  width: '100%',
})

export const StyledSubHeaderContainer = styled('div', ({ $theme }) => ({
  color: $theme.colors.grey,
  fontWeight: 400,
  letterSpacing: '-0.008px',
  fontSize: '0.875rem',
  marginTop: '.25rem',
}))

export const PanelOverrides = {
  Header: {
    style: ({ $theme }) => ({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      paddingTop: '0rem',
      paddingBottom: '0rem',
      paddingLeft: '0rem',
      paddingRight: '0rem',
      ':hover': {
        color: $theme.colors.black,
      },
    }),
  },
  PanelContainer: {
    style: {
      borderBottomWidth: '0rem',
      paddingTop: '0.6rem',
      paddingBottom: '0.6rem',
      paddingLeft: '0rem',
      paddingRight: '0rem',
    },
  },
  Content: {
    style: {
      marginTop: '1.25rem',
      marginBottom: '0rem',
      marginLeft: '0rem',
      marginRight: '0rem',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
}
